import { render, staticRenderFns } from "./admin-tm-user.vue?vue&type=template&id=a84dcec0"
import script from "./admin-tm-user.vue?vue&type=script&lang=js"
export * from "./admin-tm-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports